import FullScreenContainer from "../../components/FullScreenContainer";
import { Helmet } from "react-helmet";
import Button from "../../components/ui-lib/buttons/Button";
import manuel from "./images/mka.jpg";
import severin from "./images/sha.jpg";
import jan from "./images/jak.jpg";

function AboutUs() {
  return (
    <>
      <Helmet>
        <meta name="description" content="Wer steht hinter Nidesso." />
        <title>Nidesso | Über Nidesso und das Team dahinter.</title>
      </Helmet>
      <div>
        <FullScreenContainer
          centerContent={true}
          className="bg-th-secondary-900 bg-center bg-no-repeat"
        >
          <div
            className="my-16 flex h-full w-[80%] flex-col text-start font-sans text-base text-gray-200
                      sm:flex-col
                      sm:text-lg
                      md:flex-col
                      md:text-lg
                      lg:flex-col
                      lg:text-lg
                      xl:flex-row
                      xl:flex-wrap
                      xl:text-xl
                      "
          >
            <div
              className="order-1 flex h-full w-full flex-col pr-0 sm:w-full
                        md:w-full
                        lg:w-full
                        xl:w-1/2
                        xl:pr-4
                        "
            >
              <h2
                className="text-3xl font-bold text-gray-200
                        sm:text-3xl
                        md:text-5xl
                        lg:text-5xl
                        xl:text-5xl
                        "
              >
                Wie alles begann...
              </h2>
              <br />
              <p>
                Das junge Startup Nidesso wurde im Jahr 2022 von drei
                Studierenden der Fachhochschule Nordwestschweiz gegründet. Die
                Vision war es, eine Vermittlungsplattform zu entwickeln, die die
                Suche nach Vertretungslehrpersonen erleichtert. Schon in den
                ersten Monaten konnte das Startup mit dieser Idee den zweiten
                Platz bei der FHNW Swiss Startup Challenge gewinnen. In enger
                Zusammenarbeit mit mehreren Schulen und Lehrpersonen wurde die
                Idee kontinuierlich weiterentwickelt. Schnell stellte sich
                heraus, dass insbesondere grössere Schulen mehr als nur eine
                Vermittlungsplattform benötigten. Es musste eine übergreifende
                Lösung her, die den gesamten Prozess für Schulleiter,
                Schulsekretariate sowie Lehrpersonen grundlegend vereinfachte.
                Mit dem Ziel, dieses Problem zu lösen, entwickelte das Team von
                Nidesso die erste Version ihrer Softwarelösung. Diese wird im
                kommenden Schuljahr 2024 bei mehreren Schulen als Beta-Test
                eingesetzt.
              </p>
            </div>

            <div className="order-3 my-8 flex h-full w-full pr-0 xl:w-1/2 xl:pr-4">
              <p>
                Sind Sie interessiert, kostenlos am Beta-Test teilzunehmen oder
                mehr über Nidesso zu erfahren? Wir freuen uns, Ihnen unsere
                Lösung unverbindlich vorstellen zu dürfen.
              </p>
            </div>

            <div className="order-4 w-1/2"></div>

            <div className="order-5 flex h-full w-full xl:w-1/2">
              <Button
                className=" mx-auto block"
                theme="primary"
                onClick={() => {
                  window.location.href = "mailto:info@nidesso.ch";
                }}
              >
                Termin vereinbaren
              </Button>
            </div>

            <div
              className="order-2 mt-4 hidden w-full items-center sm:block md:w-full
                        lg:w-full
                        xl:mt-16
                        xl:w-1/2
                        "
            >
              <div className=" flex w-full flex-col rounded-xl bg-slate-600 shadow-2xl">
                <div className="h-1/6 w-full rounded-tl-xl rounded-tr-xl border-b-2 border-b-gray-200 bg-[#FFFFFF]">
                  <svg
                    className="ml-2"
                    width="80"
                    height="18"
                    viewBox="0 0 203 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="17.5" cy="17.5" r="17.5" fill="#5C9987" />
                    <circle cx="101.5" cy="17.5" r="17.5" fill="#F3A42E" />
                    <circle cx="185.5" cy="17.5" r="17.5" fill="#FF7676" />
                  </svg>
                </div>
                <p className="ml-8 mt-4 self-start font-sans text-2xl font-bold text-gray-200">
                  Swiss Startup Challenge 2022
                </p>
                <div className="p-8">
                  <div className="relative h-0 w-full pb-[56.25%]">
                    <iframe
                      className="absolute h-full w-full rounded-xl"
                      src="https://www.youtube.com/embed/J3mbDanfoQQ?modestbranding=1&fs=0&showinfo=0&rel=0"
                      title="YouTube video player"
                      allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FullScreenContainer>

        <FullScreenContainer className="bg-withe flex">
          <div className="my-auto w-full text-center">
            <h2
              className="ms:text-3xl mb-12 mt-12 text-3xl font-bold
                        text-th-secondary-900
                        md:text-3xl
                        lg:text-5xl
                        xl:text-5xl
                        "
            >
              Das Team hinter Nidesso
            </h2>
            <div className="m-auto grid w-full max-w-7xl gap-4 p-4 font-sans lg:grid-cols-3">
              <div className="text-center">
                <img
                  className="mx-auto mb-4 h-[260px] w-[240px] rounded-full border-8 border-gray-500 object-cover"
                  src={manuel}
                  alt="Manuel Käch"
                />
                <h3 className="text-th-secondary-900">Manuel Käch</h3>
                <span className="mt-2 font-bold text-gray-500">
                  BSc Wirtschaftsingenieur
                </span>
                <p className="mx-auto mt-2 w-[90%]">
                  Manuel ist für den Kundenkontakt verantwortlich und sorgt
                  dafür, dass die Anliegen der Kunden professionell bearbeitet
                  werden. Als Bindeglied zwischen Kunden und Entwicklern
                  ermittelt er, welche Anforderungen die Produkte erfüllen
                  müssen, um den Bedürfnissen der Kunden gerecht zu werden.
                  Zudem ist Manuel im Marketing tätig, um die Marke bekannt zu
                  machen und neue Kunden zu gewinnen. Neben den beiden
                  Tätigkeiten unterstützt er auch gerne das Frontend-Team bei
                  der Gestaltung der Webanwendung, um eine ansprechende
                  Nutzererfahrung zu gewährleisten.
                </p>
              </div>
              <div className="mt-14 text-center lg:mt-28">
                <img
                  className="mx-auto mb-4 h-[260px] w-[240px] rounded-full border-8 border-gray-500 object-cover"
                  src={jan}
                  alt=""
                />
                <h3 className="text-th-secondary-900">Jan Kuonen</h3>
                <span className="mt-2 font-bold text-gray-500">
                  BSc Informatik
                </span>
                <p className="mx-auto mt-2 w-[90%]">
                  Jan ist der Spezialist für die Backend-Entwicklung. Er kümmert
                  sich um die Erstellung und Verwaltung der Serverlogik, die das
                  Rückgrat unserer Anwendungen bildet. Jan sorgt dafür, dass die
                  Daten sicher gespeichert und effizient verarbeitet werden,
                  sodass unsere Kunden eine reibungslose Erfahrung auf unserer
                  Plattform haben.
                </p>
              </div>
              <div className="mt-14 flex flex-col text-center lg:mt-0">
                <img
                  className="mx-auto mb-4 h-[260px] w-[240px] rounded-full border-8 border-gray-500 object-cover"
                  src={severin}
                  alt=""
                />
                <div className="mb-12 lg:mb-28">
                  <h3 className="text-th-secondary-900">Severin Haas</h3>
                  <span className="mt-2 font-bold text-gray-500">
                    BSc Informatik
                  </span>
                  <p className="mx-auto mt-2 w-[90%]">
                    Severin ist für die Frontend-Entwicklung verantwortlich. Er
                    entwickelt die Benutzeroberfläche der Produkte und sorgt
                    dafür, dass sie technisch einwandfrei funktioniert. Er
                    gestaltet das Frontend-Design, um sicherzustellen, dass die
                    Webanwendung sowohl visuell ansprechend als auch
                    benutzerfreundlich ist. Zusätzlich setzt Severin neue
                    Features um. Er arbeitet daran, die neuesten Funktionen in
                    unsere Software zu integrieren und sorgt dafür, dass sie
                    reibungslos funktionieren.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FullScreenContainer>
      </div>
    </>
  );
}

export default AboutUs;
